import { useContext } from "react";
import { fetchData } from "../../utils/fetch";
import { LanguageContext } from "../../utils/lang_provider";

export default function Newsletter() {
  const { language } = useContext(LanguageContext);
  const fileName = "newsletter";

  const handleDownload = async () => {
    try {
      const response = await fetchData('admin/newsletter', language);
      downloadCSV(response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const extractEmails = (data) => {
    return data.map(item => ({ email: item.email }));
  };

  const convertToCSV = (objArray) => {
    const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
    let str = '';

    array.forEach(item => {
      str += item.email + '\r\n';
    });

    return str;
  };

  const downloadCSV = (data) => {
    const csvData = new Blob([convertToCSV(extractEmails(data))], { type: 'text/csv' });
    const csvURL = URL.createObjectURL(csvData);
    const link = document.createElement('a');
    link.href = csvURL;
    link.download = `${fileName}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <button onClick={handleDownload}>
      Download CSV
    </button>
  );
}